import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const refreshCode = async (params) => {
	const form = {
		base: params.base,
		item: {
			id: params.detail?.id || params.detail?.ID_INVENTARIO,
			...params.detail,
		},
	};

	const { data } = await axios.post(`${API}/admin/codes/refresh`, {
		...form,
	});
	return data;
};
